import { render, staticRenderFns } from "./fanshui.vue?vue&type=template&id=2fce4e80&scoped=true"
import script from "./fanshui.vue?vue&type=script&lang=js"
export * from "./fanshui.vue?vue&type=script&lang=js"
import style0 from "./fanshui.vue?vue&type=style&index=0&id=2fce4e80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fce4e80",
  null
  
)

export default component.exports